export const Actions = {
  async deactivateLicense({ dispatch }) {
    const results = {};
    await dispatch('getLicense');
    return results;
  },

  async resumeCloud() {
    try {
      const results = {};
      return { ok: true, results };
    } catch (err) {
      return { ok: false, err };
    }
  },
  async deactivateCloud() {
    try {
      const results = {};
      return { ok: true, results };
    } catch (err) {
      return { ok: false, err };
    }
  },
};
